<template>
  <b-form-group :label="$t($attrs['label-text'])">
    <ValidationProvider
      ref="fieldValidator"
      v-slot="{ errors }"
      :rules="rules || ''"
      :vid="$attrs.name || ''"
      mode="eager"
    >
      <div class="q-mb-md">
        <!-- <b-input-group> -->
        <!-- <b-form-input
            :value="inputValue"
            type="text"
            placeholder="YYYY-MM-DD"
            readonly
          ></b-form-input> -->
        <!-- <b-input-group-append> -->
        <!-- <label class="block text-gray-600 text-sm font-bold mb-2" for="date">Select Date</label> -->
        <v-date-picker
          :locale="isRight ? 'ar-EG' : 'en-us'"
          :right="isRight"
          :value="inputValues"
          @context="onContext"
          @input="
            (v) => {
              onContext({ selectedYMD: v });
            }
          "
        >
          <template #default="{ inputValue, inputEvents }">
            <input
              class="form-control rounded"
              :value="inputValue"
              placeholder="YYYY-MM-DD"
              v-on="inputEvents"
            >
          </template>
        </v-date-picker>
        <!-- <b-form-datepicker
              v-if="!disabled"
              ref="picker"
              :value="inputValue"
              button-only
              :right="isRight"
              size="sm"
              :locale="isRight ? 'ar-EG' : 'en-us'"
              variant="primary"
              selected-variant="primary"
              aria-controls="example-input"
              @context="onContext"
              @input="
                (v) => {
                  onContext({ selectedYMD: v });
                }
              "
            ></b-form-datepicker> -->
        <!-- </b-input-group-append> -->
        <!-- </b-input-group> -->
        <small
          :class="{ 'd-none': !$attrs['label-text'] }"
          class="text-danger"
        >{{ errors[0] }}</small>
      </div>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },
  props: {
    dir: {
      type: String,
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: [Number, String, Boolean],
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
  },
  emits: ['update:value'],
  data() {
    return {
      inputValues: '',
    };
  },
  watch: {
    value(newVale) {
      if (newVale != null) {
        this.inputValues = this.getDate(newVale);
      }
    },
  },
  mounted() {
    this.inputValues = this.getDate(this.value);
  },
  methods: {
    onContext(ctx) {
      if (ctx.selectedYMD != null) {
        this.inputValues = this.getDate(ctx.selectedYMD);
      } else if ((this.$attrs.name === 'fromDate' || this.$attrs.name === 'toDate') && ctx.selectedYMD === null) {
        this.inputValues = null;
      }
      this.$emit('update:value', this.inputValues);
      this.$emit('change', this.inputValues);
    },
  },
};
</script>

<style></style>
